import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from '@mui/material';

import { useDeleteChannel } from '@/features/channels';
import { Button } from '@/shared/ui/lib/Button';
import { SvgIcon } from '@/shared/ui/SvgIcon';

export const SettingsDeleteChannelButton = ({
  channelId,
  disabled,
  disabledReason,
}: {
  channelId: string;
  disabled?: boolean;
  disabledReason?: string;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { deleteChannel, isPending } = useDeleteChannel();

  const handleDeleteChannel = async () => {
    await deleteChannel(channelId, () => {
      navigate('/channels');
    });
  };

  const button = (
    <Button
      variant="outlined"
      startIcon={<SvgIcon name="trash" />}
      sx={{ minWidth: 160 }}
      onClick={handleDeleteChannel}
      disabled={!channelId || disabled || isPending}
    >
      {t('channels:deleteChannel')}
    </Button>
  );

  const wrappedButton = (
    <span style={{ display: 'inline-flex', marginLeft: 'auto' }}>{button}</span>
  );

  if (!disabledReason) return wrappedButton;

  return (
    <Tooltip title={disabledReason}>
      {wrappedButton}
    </Tooltip>
  );
};
